import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL || '';

export function useApi() {
  const { getToken, logout } = useAuth();

  const apiFetch = useCallback(async (path, options = {}) => {
    const token = getToken();
    const res = await fetch(`${API}${path}`, {
      ...options,
      headers: {
        // Con FormData (imágenes) el navegador pone el Content-Type con su boundary
        ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
    });

    // Cualquier 401 (token expirado, inválido o ausente) → volver al login.
    // Antes solo se hacía con TOKEN_EXPIRED y la página quedaba "colgada".
    if (res.status === 401) {
      const data = await res.json().catch(() => ({}));
      logout();
      throw new Error(data.error || 'Sesión no válida');
    }

    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      // El admin restableció la contraseña: recargar lleva a la pantalla de cambio
      if (data.code === 'PASSWORD_CHANGE_REQUIRED') window.location.reload();
      const err = new Error(data.error || `Error ${res.status}`);
      err.status = res.status;
      err.code = data.code;
      err.data = data;
      throw err;
    }

    // Archivos (p. ej. el reporte en Excel): se devuelve el contenido y el nombre sugerido
    if (options.asFile) {
      const name = /filename="([^"]+)"/.exec(res.headers.get('Content-Disposition') || '')?.[1] || 'archivo';
      return { blob: await res.blob(), name };
    }

    const data = await res.json();
    // Listas paginadas: el total viene en el encabezado X-Total-Count
    if (options.withTotal) {
      const total = res.headers.get('X-Total-Count');
      return { data, total: total != null ? Number(total) : null };
    }
    return data;
  }, [getToken, logout]);

  return { apiFetch };
}
